<template>
  <figcaption :class="style['chat-info']">
    <span :class="style['avatar']" :style="computedConciergeImage"></span>
    <time>{{ computedDateTime }}</time>
  </figcaption>
</template>

<script>
import { checkImage, formatTime, formatDate } from 'Utilities'
import style from './scss/_users.scss'

export default {
  props: {
    settings: { type: Object, required: true }
  },
  data() {
    return {
      chatBubbleIcon: '',
      style
    }
  },
  computed: {
    computedConciergeImage() {
      checkImage(this.settings[this.$i18n.locale].icon.icon_image_url, '').then((image) => {
        if (image !== '') {
          this.chatBubbleIcon = `background-image: url(${image});`
        } else {
          this.chatBubbleIcon = ''
        }
      })
      return this.chatBubbleIcon
    },
    computedDateTime() {
      const currentDateTime = Date.now()
      const dateObject = new Date(currentDateTime)
      return `${formatDate(dateObject, 'yyyy/MM/dd')} - ${formatTime(currentDateTime)}`
    }
  }
}
</script>
